import React, { useContext } from 'react'
import {
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  styled,
} from '@mui/material'
import Controls from '../Controls/Controls'

import Dialog from './Dialog'
import { AuthContext } from '../../Context/AuthContext'

const Header = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  paddingLeft: 20,
  justifyContent: 'center',
  alignItems: 'center',
  marginInline: 40,
  '@media (max-width: 400px)': {
    paddingLeft: 0,
  },
})

const Root = styled(DialogContent)({
  '& .MuiDialogContent-root': {
    '@media (max-width: 400px)': {
      padding: '8px 5px',
    },
  },
})

const Close = styled('div')({
  position: 'absolute',
  right: 10,
})

const Content = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
})

const Text = styled('p')({
  fontSize: '1rem',
  margin: '5px 0',
  textAlign: 'center',
})

const Bold = styled('span')({
  fontWeight: 'bold',
})

const Otp = styled('div')({
  padding: '20px 0',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  '@media (max-width: 400px)': {
    paddingBlock: 0,
  },
})

const Link = styled('a')({
  textDecorationLine: 'underline',
  color: '#5687E1',
  '&:hover': {
    cursor: 'pointer',
  },
})

const InputStyle = styled('input')({
  fontSize: '24px',
  margin: '0px 10px',
  padding: '0px',
})

const OtpField = styled('div')({
  margin: '20px 0px 0px 0px',
})

const ApproveTnCDialog = ({ open, close, isTutorFlow }) => {
  const { AcceptTnC } = useContext(AuthContext)

  const handleVerify = async () => {
    await AcceptTnC()
    window.location.reload(false)
    close()
  }

  return (
    <Dialog open={open} fullWidth={false}>
      <DialogTitle>
        <Header>
          <p className="sub-text bold text-align-center">
            Terms & Conditions Updated!
          </p>
        </Header>
      </DialogTitle>
      <Divider />
      <Root>
        <Content>
          <Text>
            By accessing or using edvi&apos;s services, website, or mobile
            applications (the &quot;Service&quot;), you acknowledge that you
            have read, understood, and agree to be bound by our{' '}
            <a
              href={
                isTutorFlow
                  ? 'https://policies.edvi.app/tutor/terms'
                  : 'https://policies.edvi.app/terms'
              }
              target="_blank"
              rel="noopener noreferrer"
            >
              {isTutorFlow
                ? 'Terms and Conditions and Privacy Policy.'
                : 'Terms and Conditions'}
            </a>
            {isTutorFlow ? '' : ' and '}
            {isTutorFlow ? (
              ''
            ) : (
              <a
                href="https://policies.edvi.app/privacy"
                target="_blank"
                rel="noopener noreferrer"
              >
                Privacy Policy.
              </a>
            )}{' '}
            If you do not agree to these terms, you must refrain from using the
            Service.
          </Text>
        </Content>
      </Root>
      <Divider />
      <DialogActions>
        <Controls.Button onClick={handleVerify} style={{ margin: '0.5rem' }}>
          Accept Now
        </Controls.Button>
      </DialogActions>
    </Dialog>
  )
}

export default ApproveTnCDialog
